<template>
  <div class="animated fadeIn">
    <!-- <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <b-col lg="12" class="ml-auto"></b-col>

    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h5 class="m-0 pt-1">ادغام دو محصول</h5>
      </template>
      <loading v-if="vLoading" />
      <br />
      <b-card class="shadow p-3 mb-5 bc-white rounded">
        <div v-show="product1" class="animated fadeIn">
          <h5>محصول اول را از لیست زیر انتخاب نمایید:</h5>
          <hr />
          <br />
          <v-text-field
            clearable
            v-model="filter"
            id="filterInput"
            placeholder="جستجو"
            outlined
            dense
          ></v-text-field>

          <b-table
            responsive
            show-empty
            id="productsTable"
            :items="products"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="currentPage"
            :per-page="perPage"
            :busy="isBusy"
            :filter="filter"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>



            <template v-slot:cell(progress)="data">
              <b-progress
                :value="data.item.progress"
                variant="success"
                :striped="striped"
                show-progress
                animated
              ></b-progress>
            </template>
            <template v-slot:cell(operation)="row">
              <a href="#top"><b-btn variant="warning" @click="chooseFirst(row.item)"
                >انتخاب</b-btn
              ></a>
            </template>

            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <div
              slot="table-busy"
              class="text-center text-danger my-2"
            >
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            aria-controls="productsTable"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
        </div>
        <div v-show="product2" class="animated fadeIn">
          <b-table
            responsive
            show-empty
            id="productsTable"
            :items="products.filter(x => x.id == productSelected)"
            :fields="fields4"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="currentPage"
            :per-page="perPage"
            :busy="isBusy"
            :filter="filter"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>


            <template v-slot:cell(number)>
              {{ finalNumber }}
            </template>

            <template v-slot:cell(progress)="data">
              <b-progress
                :value="data.item.progress"
                variant="success"
                :striped="striped"
                show-progress
                animated
              ></b-progress>
            </template>
            <template v-slot:cell(operation)="row">
              <b-btn variant="danger" @click="previous(row.data)"
                >حذف و بازگشت</b-btn
              >
            </template>

            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <div
              slot="table-busy"
              class="text-center text-danger my-2"
            >
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <br />
          <br />
          <h5>محصول دوم را از لیست زیر انتخاب نمایید:</h5>
          <hr />
          <br />
          <v-text-field
            clearable
            v-model="filter"
            id="filterInput"
            placeholder="جستجو"
            outlined
            dense
          ></v-text-field>
          <b-table
            responsive
            show-empty
            id="productsTable"
            :items="
              products.filter(
                x =>
                  x.warehouseSectionId == sectionSelected &&
                  x.id != productSelected
              )
            "
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="currentPage"
            :per-page="perPage"
            :busy="isBusy"
            :filter="filter"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>



            <template v-slot:cell(progress)="data">
              <b-progress
                :value="data.item.progress"
                variant="success"
                :striped="striped"
                show-progress
                animated
              ></b-progress>
            </template>
            <template v-slot:cell(operation)="row">
              <a href="#top"><b-btn variant="warning" @click="chooseSecond(row.item)"
                >انتخاب</b-btn
              ></a>
            </template>

            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <div
              slot="table-busy"
              class="text-center text-danger my-2"
            >
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            aria-controls="productsTable"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
        </div>
        <div v-show="compare" class="animated fadeIn">
          <v-row>
            <v-col>
              <h5>محصول نهایی مورد نظر را انتخاب نمایید:</h5>
            </v-col>
            <v-col style="vertical-align: middle;">
              <v-btn
                class="text-light float-left primary"
                @click="previous2()"
              >
                بازگشت به قبل
              </v-btn>
            </v-col>
          </v-row>
          <hr />
          <br />
          <b-table
            responsive
            show-empty
            id="productsTable"
            :items="
              products.filter(
                x =>
                  x.id == productSelected ||
                  x.id == productSelected2 ||
                  x.id == finalProduct
              )
            "
            :fields="fields2"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            bordered
            :current-page="currentPage"
            :per-page="perPage"
            :busy="isBusy"
            :filter="filter"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle;">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle;">
                {{ data.value }}
              </div>
            </template>



            <template v-slot:cell(progress)="data">
              <b-progress
                :value="data.item.progress"
                variant="success"
                :striped="striped"
                show-progress
                animated
              ></b-progress>
            </template>
            <template v-slot:cell(operation)="row">
              <b-btn variant="warning" @click="finalChoose(row.item)"
                >انتخاب به عنوان محصول نهایی</b-btn
              >
            </template>
            <div
              slot="table-busy"
              class="text-center text-danger my-2"
            >
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <br />
          <br />
          <br />
          <div v-show="merged" style="text-align: center">
            <b-table
              responsive
              show-empty
              id="productsTable"
              :items="products.filter(x => x.id == finalProduct)"
              :fields="fields3"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              bordered
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              
              <template v-slot:cell(number)>
                {{ finalNumber }}
              </template>

              <template v-slot:cell(progress)="data">
                <b-progress
                  :value="data.item.progress"
                  variant="success"
                  :striped="striped"
                  show-progress
                  animated
                ></b-progress>
              </template>
              <template v-slot:cell(operation)="row">
                <b-btn variant="warning" @click="chooseSecond(row.item)"
                  >انتخاب</b-btn
                >
              </template>

              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <div
                slot="table-busy"
                class="text-center text-danger my-2"
              >
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <br />
            <v-btn  class="text-light primary" @click="mergeProducts()">
              تایید
            </v-btn>
          </div>
        </div>
      </b-card>
    </b-card> -->

    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data: function () {
    return {
      products: [],
      productFilter: "all",
      productSelected: "",
      sectionSelected: "",
      productSelected2: "",
      finalProduct: "",
      finalNumber: "",
      mergeProduct: "",
      product1: true,
      product2: false,
      compare: false,
      isBusy: false,
      merged: false,
      moment: moment,
      showProgress: false,
      items: [],
      filter: null,
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "number", label: "موجودی" },
        { key: "description", label: "توضیحات" },
        { key: "operation", label: "عملیات" },
      ],
      fields2: [
        { key: "name", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "number", label: "موجودی" },
        { key: "description", label: "توضیحات" },
        { key: "operation", label: "عملیات" },
      ],
      fields3: [
        { key: "name", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "number", label: "موجودی" },
        { key: "description", label: "توضیحات" },
      ],
      fields4: [
        { key: "name", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "number", label: "موجودی" },
        { key: "description", label: "توضیحات" },
        { key: "operation", label: "عملیات" },
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      isBusy2: false,
      TotalRows: 1,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
    };
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.allTotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    chooseFirst(item1) {
      this.productSelected = item1.id;
      this.sectionSelected = item1.warehouseSectionId;
      this.product1 = false;
      this.product2 = true;
      this.filter = "";
      // console.log("productSelected:" + this.productSelected);
      // console.log("sectionSelected:" + this.sectionSelected);
    },
    previous(item) {
      this.product1 = true;
      this.product2 = false;
    },
    previous2() {
      this.compare = false;
      this.product2 = true;
      this.finalProduct = "";
      this.merged = false;
    },
    chooseSecond(item2) {
      this.productSelected2 = item2.id;
      // console.log("productSelected2:" + this.productSelected2);
      this.product2 = false;
      this.compare = true;
      let list = this.products.filter(
        (x) => x.id == this.productSelected || x.id == this.productSelected2
      );
      this.fields2.forEach((field) => {
        if (
          field.key != "number" &&
          field.key != "check" &&
          field.key != "operation"
        ) {
          if (list[0][field.key] == list[1][field.key]) {
            field.variant = "success";
          } else {
            field.variant = "danger";
          }
        } else {
          field.variant = "light";
        }
      });
    },
    finalChoose(item) {
      this.finalProduct = item.id;
      this.merged = true;
      let list = this.products.filter(
        (x) => x.id == this.productSelected || x.id == this.productSelected2
      );
      this.fields3.forEach((field) => {
        if (field.key == "number") {
          this.finalNumber = list[0].number + list[1].number;
        }
      });
      //   console.log(this.finalProduct);
      if (this.finalProduct == this.productSelected) {
        this.mergeProduct = this.productSelected2;
      } else {
        this.mergeProduct = this.productSelected;
      }
      // console.log("final: "+this.finalProduct);
      // console.log("merge: "+this.mergeProduct);
    },
    mergeProducts() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/merge",
        {
          itemId: this.mergeProduct,
          desItemId: this.finalProduct,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.compare = false;
            this.product1 = true;
            this.getAllProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getAllProducts() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItems/list",
        {
          filter: this.productFilter,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.products = res.data;
            this.TotalRows = this.products.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getAllProducts();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.nav-pills {
  padding: 10px !important;
}
.changeInventory-btn {
  display: flex;
  align-items: center;
  flex-flow: column;
}
</style>
<style lang="scss">
td {
  text-align: center;
}
</style>

sty
